// client/src/components/creditAssignment/CreditAssignmentClients.js
//
// Vista azienda (sola lettura) delle anagrafiche clienti della cessione del
// credito. "Già utilizzato" e "rimanente" sono calcolati dal backend.

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';
import { formatCurrencyWithSymbol } from '../utils/formatUtils';
import { fetchClients } from './creditAssignmentApi';

const pct = (value) => `${(value || 0).toFixed(1)}%`;

const CreditAssignmentClients = () => {
  const { t } = useTranslation();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchClients()
      .then(setClients)
      .catch(() => setError(t('creditAssignment.errors.fetchClients')))
      .finally(() => setLoading(false));
  }, [t]);

  if (loading) return <div className="loading">{t('common.loading')}</div>;

  return (
    <div className="company-dashboard">
      <div className="card">
        <div className="card-title">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <Users className="card-title-icon" size={20} />
            <span>{t('creditAssignment.clients.title')}</span>
          </div>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

        <table>
          <thead>
            <tr>
              <th>{t('creditAssignment.clients.name')}</th>
              <th>{t('creditAssignment.clients.plafond')}</th>
              <th>{t('creditAssignment.clients.used')}</th>
              <th>{t('creditAssignment.clients.remaining')}</th>
            </tr>
          </thead>
          <tbody>
            {clients.length > 0 ? (
              clients.map((c) => (
                <tr key={c.id}>
                  <td>{c.clientName}</td>
                  <td>{formatCurrencyWithSymbol(c.plafond, 'EUR')}</td>
                  <td>
                    {formatCurrencyWithSymbol(c.usedAmount, 'EUR')}{' '}
                    <span style={{ color: '#6c757d' }}>({pct(c.usedPercentage)})</span>
                  </td>
                  <td>
                    {formatCurrencyWithSymbol(c.remainingAmount, 'EUR')}{' '}
                    <span style={{ color: '#6c757d' }}>({pct(c.remainingPercentage)})</span>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">{t('creditAssignment.clients.none')}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CreditAssignmentClients;
